export const data = [
    {
     "BIN": 24269,
     "PCN": "PFORCE",
     "Group": "-",
     "Reason": "Cash BIN",
     "startDate": "07\/04\/2022"
    },
    {
     "BIN": 24532,
     "PCN": "ARX32839",
     "Group": "-",
     "Reason": "Payer Exclusion",
     "startDate": "06\/30\/2022"
    },
    {
     "BIN": 19595,
     "PCN": 1940000,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "09\/13\/2022"
    },
    {
     "BIN": 19595,
     "PCN": 7630000,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "09\/13\/2022"
    },
    {
     "BIN": 4336,
     "PCN": "ADV",
     "Group": "RX2338",
     "Reason": "Medicaid",
     "startDate": "09\/13\/2022"
    },
    {
     "BIN": 4336,
     "PCN": "MCAIDADV",
     "Group": "RX2338",
     "Reason": "Medicaid",
     "startDate": "09\/13\/2022"
    },
    {
     "BIN": 12114,
     "PCN": "COBSEGADV",
     "Group": "RX2338",
     "Reason": "Medicaid",
     "startDate": "09\/13\/2022"
    },
    {
     "BIN": 13089,
     "PCN": "COMSEGADV",
     "Group": "RX2338",
     "Reason": "Medicaid",
     "startDate": "09\/13\/2022"
    },
    {
     "BIN": 19595,
     "PCN": "PRX11804",
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "09\/13\/2022"
    },
    {
     "BIN": 4336,
     "PCN": "MCAIDADV",
     "Group": "RX3892",
     "Reason": "Medicaid",
     "startDate": "09\/13\/2022"
    },
    {
     "BIN": 19595,
     "PCN": 7630000,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "09\/13\/2022"
    },
    {
     "BIN": 19595,
     "PCN": 1940000,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "09\/13\/2022"
    },
    {
     "BIN": 610494,
     "PCN": 4200,
     "Group": "ACUPA",
     "Reason": "Medicaid",
     "startDate": "09\/13\/2022"
    },
    {
     "BIN": 3858,
     "PCN": "A4",
     "Group": "PMDM",
     "Reason": "Medicaid",
     "startDate": "09\/13\/2022"
    },
    {
     "BIN": 20107,
     "PCN": "FM",
     "Group": "WKPA",
     "Reason": "Medicaid",
     "startDate": "09\/14\/2022"
    },
    {
     "BIN": 0,
     "PCN": "-",
     "Group": "MEDICAID",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 0,
     "PCN": "-",
     "Group": "OHMEDICAID",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 0,
     "PCN": "MEDICAID",
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 0,
     "PCN": "MCAIDOH",
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 1553,
     "PCN": "AZM",
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 1553,
     "PCN": "GAM",
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 1553,
     "PCN": "INM",
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 1553,
     "PCN": "NVM",
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 1553,
     "PCN": "TNM",
     "Group": "Tenncare",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 1553,
     "PCN": "TNM",
     "Group": "TNM",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 1844,
     "PCN": "3F",
     "Group": "FVINB19",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 2286,
     "PCN": 102286,
     "Group": "ADAP",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 2286,
     "PCN": 102286,
     "Group": "PACE",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019",
     "endDate": "09\/06\/2022"
    },
    {
     "BIN": 2286,
     "PCN": 102286,
     "Group": "ADAP",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": "33000HFM",
     "Group": "FHP9198",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": "33000HFM",
     "Group": "HCP9198",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 35017,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 36200,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 38060,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 38780,
     "Group": "OHM01",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 38900,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 38920,
     "Group": 38920,
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 38960,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 50032,
     "Group": 50032,
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 50360,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 56010,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 56270,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 56420,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 58080,
     "Group": "FHP0108",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 58080,
     "Group": "FHP9198",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 58080,
     "Group": "HCP9198",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 58110,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 74000,
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": 97892,
     "Group": "AHF04",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": "ASPROD1",
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    },
    {
     "BIN": 3585,
     "PCN": "MCO",
     "Group": "-",
     "Reason": "Medicaid",
     "startDate": "12\/31\/2019"
    }
];